/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Allcountries1Inputs */

const en_allcountries1 = /** @type {(inputs: Allcountries1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`All Countries`)
};

const de_allcountries1 = /** @type {(inputs: Allcountries1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Alle Länder`)
};

/**
* | output |
* | --- |
* | "All Countries" |
*
* @param {Allcountries1Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const allcountries1 = /** @type {((inputs?: Allcountries1Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Allcountries1Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_allcountries1(inputs)
	return de_allcountries1(inputs)
});
export { allcountries1 as "allCountries" }